define(function (require) {

    var ViewController = require('web-agent-framework/ViewController');

    var NumericInputViewController = ViewController.extend({
        ControllerName: "NumericInputViewController",

        LPViewMap: {
            input: ".lpview_numeric_input"
        },
        directionType: {
            min: 'min',
            max: 'max'
        },
        initialize: function (constructorData) {
            this.createView({templateFile: "LP_numeric_input.html"});
            this.defaultInputValue = typeof constructorData.defaultInputValue === 'number' ? constructorData.defaultInputValue : 0;
            this.minimumInputValue = typeof constructorData.minimumInputValue === 'number' ? constructorData.minimumInputValue : null;
            this.maximumInputValue = typeof constructorData.maximumInputValue === 'number' ? constructorData.maximumInputValue : null;
            this.valueChangedCallback = constructorData.valueChangedCallback;
            this.revertOnBlur = constructorData.revertOnBlur;
            this.lostFocusCallback = constructorData.lostFocusCallback;
            this.context = constructorData.context || this;
            this.inputElement = this.getFirstElement(this.LPViewMap.input);
            this.checkCurrentValue();
        },

        events: function () {
            this.bindViewEvent({selector : this.LPViewMap.input, DOMEvent : 'keyup',    callback : this.handleKeyUp});
            this.bindViewEvent({selector : this.LPViewMap.input, DOMEvent : "paste",    callback : this.handleCutPasteEvent});
            this.bindViewEvent({selector : this.LPViewMap.input, DOMEvent : "cut",      callback : this.handleCutPasteEvent});
            this.bindViewEvent({selector : this.LPViewMap.input, DOMEvent : "dragend",  callback : this.handleCutPasteEvent});
            this.bindViewEvent({selector : this.LPViewMap.input, DOMEvent : "drop",     callback : this.handleCutPasteEvent});
            this.bindViewEvent({selector : this.LPViewMap.input, DOMEvent : 'blur',     callback : this.handleBlur});
            this.bindViewEvent({selector : this.LPViewMap.input, DOMEvent : 'focus',    callback : this.onFocus});
        }
    });

    NumericInputViewController.prototype.handleCutPasteEvent = function (data) {
        var that = this;
        setTimeout(function () {
            that.handleKeyUp(data);
        }, 0);
    };

    NumericInputViewController.prototype.handleKeyUp = function (data) {
        var keyCode = data.keyCode || data.which;
        var inputValue = filterInt(data.sourceElement.value);
        if (data.sourceElement.value === '' || data.sourceElement.value === '-') {
            return;
        }
        if (isNaN(inputValue) && data.sourceElement.value !== '') {
            this.restorePreviousValue();
        } else if (!this.isValueInTheRange(inputValue)) {
            this.restorePreviousValue();
        } else if (keyCode !== 13) {
            this.tempValue = inputValue;
            return;
        } else {
            this.checkAndApplyTempInputValue(inputValue);
        }

        function filterInt(value) {
            if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
                return Number(value);
            }
            return NaN;
        }
    };

    NumericInputViewController.prototype.checkAndApplyTempInputValue = function (inputValue) {
        if (typeof inputValue !== 'undefined') {
            this.tempValue = undefined;
            if (!isNaN(inputValue) && this.isValueInTheRange(inputValue)) {
                this.currentInputValue = inputValue;
                if (this.valueChangedCallback) {
                    this.valueChangedCallback.call(this.context, this.currentInputValue);
                }
            } else {
                this.updateCurrentInputValue();
            }
        }
    };

    NumericInputViewController.prototype.onFocus = function () {
        var that = this;
        setTimeout(function(){that.inputElement.select();},0);
    };

    NumericInputViewController.prototype.handleBlur = function (e) {
        if (this.revertOnBlur) {
            this.updateCurrentInputValue();
        } else {
            this.checkAndApplyTempInputValue(this.tempValue);
        }
        this.applyLostFocusCallback(e);
    };

    NumericInputViewController.prototype.isValueInTheRange = function (value) {
        var result = true;
        if (typeof this.minimumInputValue === 'number') {
            result = result && value >= this.minimumInputValue;
        }
        if (typeof this.maximumInputValue === 'number') {
            result = result && value <= this.maximumInputValue;
        }
        return result;
    };

    NumericInputViewController.prototype.restorePreviousValue = function () {
        this.inputElement.value = typeof this.tempValue !== 'undefined' ? this.tempValue : this.currentInputValue;
    };
    NumericInputViewController.prototype.updateCurrentInputValue = function () {
        this.tempValue = undefined;
        this.inputElement.value = this.currentInputValue;
    };

    NumericInputViewController.prototype.setMinimumInputValue = function (minimum) {
        if (typeof minimum === 'number' && minimum !== this.minimumInputValue) {
            this.minimumInputValue = minimum;
            this.checkCurrentValue(this.directionType.min);
        } else if (typeof minimum !== 'number' && typeof this.minimumInputValue === 'number') {
            this.minimumInputValue = null;
            this.checkCurrentValue();
        }
    };

    NumericInputViewController.prototype.setMaximumInputValue = function (maximum) {
        if (typeof maximum === 'number' && maximum !== this.maximumInputValue) {
            this.maximumInputValue = maximum;
            this.checkCurrentValue(this.directionType.max);
        } else if (typeof maximum !== 'number' && typeof this.maximumInputValue === 'number') {
            this.maximumInputValue = null;
            this.checkCurrentValue();
        }
    };

    NumericInputViewController.prototype.setCurrentInputValue = function (current) {
        if (typeof current === 'number') {
            this.setCurrentValue(current);
            this.checkCurrentValue();
        }
    };

    NumericInputViewController.prototype.checkCurrentValue = function (direction) {
        if (typeof this.maximumInputValue === 'number' && typeof this.minimumInputValue === 'number' &&
            this.maximumInputValue < this.minimumInputValue) {
            this.maximumInputValue = this.minimumInputValue;
        }
        if (!this.isValueInTheRange(this.currentInputValue)) {
            switch (direction) {
                case this.directionType.min:
                    if (typeof this.minimumInputValue === 'number') {
                        this.defaultInputValue = this.minimumInputValue;
                    }
                    break;
                case this.directionType.max:
                    if (typeof this.maximumInputValue === 'number') {
                        this.defaultInputValue = this.maximumInputValue;
                    }
                    break;
                default:
                    if (typeof this.minimumInputValue === 'number') {
                        this.defaultInputValue = this.minimumInputValue;
                    } else if (typeof this.maximumInputValue === 'number') {
                        this.defaultInputValue = this.maximumInputValue;
                    }
            }

        }
        var shouldNotify = typeof this.currentInputValue !== 'undefined';
        if (!shouldNotify || !this.isValueInTheRange(this.currentInputValue)) {
            this.setCurrentValue(this.defaultInputValue);
            if (shouldNotify && this.valueChangedCallback) {
                this.valueChangedCallback.call(this.context, this.currentInputValue);
            }
        }
    };

    NumericInputViewController.prototype.setCurrentValue = function (value) {
        this.currentInputValue = value;
        this.inputElement.value = value;
    };

    NumericInputViewController.prototype.setDefaultValue = function (value) {
        this.defaultInputValue = value;
    };

    NumericInputViewController.prototype.applyLostFocusCallback = function (e) {
        if (this.lostFocusCallback) {
            this.lostFocusCallback.call(this.context, e);
        }
    };

    return NumericInputViewController;

});
